import React, { useEffect } from 'react';
import { TrackingProvider } from '../context/TrackingContext.jsx';
import { LoadingProvider } from '../context/LoadingContext.jsx';
import Routes from './AppRoutes';
import * as Sentry from '@sentry/react';
import { ErrorFallback } from './common/ErrorFallback.jsx';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; // Import styles globally
import redirectSpinner from './common/redirectSpinner.js';

Sentry.init({
  dsn: window.location.hostname === 'localhost' ? null : import.meta.env.VITE_APP_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration()
  ],
  debug: false,
  environment: import.meta.env.VITE_APP_ENV || 'development',
  tracesSampleRate: 1.0,
  tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  beforeSend: async event => {
    redirectSpinner();
    await Sentry.flush(1000); // wait 2 max seconds for the event to be sent to Sentry before redirecting
    console.log('check if hit!, beforeSend called');
    window.top.location.replace('https://www.hannamfertility.com/booking-call-clinic');
    return event;
  }
});

export default function App() {
  console.log('VITE_MY_VAR =', import.meta.env.VITE_VR_ACUITY_LINK);
  return (
    <Sentry.ErrorBoundary fallback={ErrorFallback}>
      <TrackingProvider>
        <LoadingProvider>
          <>
            <Routes />
            <ToastContainer
              position="top-right"
              autoClose={3000}
              hideProgressBar={false}
              newestOnTop={true}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="colored"
            />
          </>
        </LoadingProvider>
      </TrackingProvider>
    </Sentry.ErrorBoundary>
  );
}
